import Vue from "vue";
import App from "./App.vue";
import store from "./store/index";
import router from "./router/index";
import { $get, $post } from "./utils/http";
import ElementUI from "element-ui";
import VueLazyLoad from "vue-lazyload";
import "element-ui/lib/theme-chalk/index.css";
import "../src/assets/initialize.css";
import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);
// import './assets/js/.js'

// /* 头部组件 */
import MyHeader from "@/components/MyHeader";
Vue.component("MyHeader", MyHeader);
import MyFooter from "@/components/MyFooter";
Vue.component("MyFooter", MyFooter);

// /* 回到顶部 */

import GoTop from "@/components/GoTop";
Vue.component("GoTop", GoTop);

Vue.config.productionTip = false;
const baseUrl = "222222";

import axios from "axios";
// 配置请求的根路径
// axios.defaults.baseURL = "http://127.0.0.1:8888/api/private/v1/";

// 请求拦截器
// axios.interceptors.request.use((config) => {
//   //console.log(config);
//   config.headers.Authorization = window.sessionStorage.getItem("token");
//   // 在最后必须return
//   return config;
// });
// 前置条件: npm i swiper@5.x vue-awesome-swiper

// import VueAwesomeSwiper from "vue-awesome-swiper";
import Swiper from "swiper"; // 注意引入的是Swiper

// import style (>= Swiper 6.x) :  我们是5版本, 所以注释这里
// import 'swiper/swiper-bundle.css'

// import style (<= Swiper 5.x)
import "swiper/css/swiper.css";

// Vue.use(VueAwesomeSwiper);
// main.js 要引入

Vue.prototype.$http = axios;

Vue.use(ElementUI);
Vue.prototype.$get = $get;
Vue.prototype.$post = $post;
Vue.config.productionTip = false;
Vue.use(VueLazyLoad, {
  loading: "/imgs/loading-svg/loading-bars.svg",
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
